import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Container,
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  Button
} from '@mui/material';
import { getCategory } from '../api/categoryApi';

const Domains = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [domains, setDomains] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Retrieve patient info from state
  const patientId = location.state?.patientId || '';
  const patientName = location.state?.patientName || '';

  useEffect(() => {
    getCategory()
      .then((res) => {
        const data = res.data?.data || [];
        const formatted = data.map((item) => ({
          code: item.code,
          label: item.name
        }));

        // Custom order
        const order = ['SE', 'PB', 'CS', 'RC', 'EC', 'GM', 'FM', 'ADL', 'SEN', 'BEH'];

        // Sort formatted according to order
        const sorted = formatted.sort(
          (a, b) => order.indexOf(a.code) - order.indexOf(b.code)
        );

        setDomains(sorted);
        setLoading(false);
      })
      .catch(() => {
        setError('Failed to fetch categories');
        setLoading(false);
      });
  }, []);

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Box textAlign="right" sx={{ mb: 2 }}>
        <Button
          variant="contained"
          onClick={() => navigate(`/patient`, { replace: true })}
        >
          Home
        </Button>
      </Box>
      <Typography variant="h4" gutterBottom>
        Developmental Domains
      </Typography>

      {/* Patient Info */}
      {patientId &&
        <Typography variant="subtitle1" sx={{ mb: 3 }}>
          Patient: <strong>{patientName}</strong> (ID: <strong>{patientId}</strong>)
        </Typography>
      }

      {loading && <Typography>Loading categories...</Typography>}
      {error && <Typography color="error">{error}</Typography>}

      <Grid container spacing={3} justifyContent="center">
        {domains.map((domain) => (
          <Grid item key={domain.code} sx={{ width: 250, display: 'flex' }}>
            <Card
              elevation={3}
              onClick={() =>
                navigate(`/domains/${domain.code}`, {
                  state: { patientId, patientName }
                })
              }
              sx={{
                height: 200,
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                cursor: 'pointer',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease, background 0.3s ease',
                boxSizing: 'border-box',
                '&:hover': {
                  transform: 'scale(1.03)',
                  boxShadow: `0 6px 20px #ea258b55`,
                  background: `linear-gradient(135deg, #ea258b, #d01e76)`,
                  color: '#ffffff'
                }
              }}
            >
              <CardContent
                sx={{
                  flexGrow: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  textAlign: 'center',
                  transition: 'color 0.3s ease',
                  width: '100%',
                  '& .MuiTypography-root': {
                    transition: 'color 0.3s ease'
                  },
                  '&:hover .MuiTypography-root': {
                    color: '#ffffff'
                  }
                }}
              >
                <Typography variant="h6" sx={{ mb: 1 }}>
                  {domain.code}
                </Typography>
                <Typography variant="body1">
                  {domain.label}
                </Typography>
              </CardContent>
            </Card>

          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default Domains;
